import {
    ActionService,
    collection,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {inject, Injectable} from "@angular/core";
import {OrderInitiationData} from '../order/order-initiation.service';

export enum OrderTransferTargetStatus {
    OPEN = "OPEN",
    CLOSED = "CLOSED",
    CLOSED_TIMEOUT = "CLOSED_TIMEOUT",
    CLOSED_CONFLICT = "CLOSED_CONFLICT",
    SAVING = "SAVING"
}

export class OrderTransferRequestsData extends EntityData<OrderTransferRequestsData> {
    @field transferTargetStatus: OrderTransferTargetStatus;
    @field transferTargetOrderType: string;
    @collection(OrderInitiationData) requests: OrderInitiationData[];
}

/**
 * Service to poll for transfer requests for a target
 */
@Injectable({providedIn: "root"})
export class OrderTransferRequestPollService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- OrderTransferRequestPollService");

        super(http, nameSpace, "app-order-transfer-request-poll", configService, useAsync, actionNames);
    }
}
